export class Summary {
    name: string;           //顧客氏名
    category: string;       //種別
    plan_date: Date;        //入金予定日
    pay_date: Date;         //入金日
    plan: number;           //予定金額
    payment: number;        //入金額
}